import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  Server,
  MessageSquare,
  Languages,
  BarChart3,
  TestTube,
  Users,
  ArrowLeft,
  Shield,
  TrendingUp,
  FlaskConical
} from 'lucide-react'
import clsx from 'clsx'

const AdminSidebar = () => {
  const location = useLocation()

  const navigation = [
    {
      name: 'LLM Providers',
      href: '/admin/providers',
      icon: Server,
      description: 'Manage LLM configurations and accounts'
    },
    {
      name: 'Instructions',
      href: '/admin/instructions',
      icon: MessageSquare,
      description: 'Translation & review prompts'
    },
    {
      name: 'Test Console',
      href: '/admin/test',
      icon: TestTube,
      description: 'Test translations live'
    },
    {
      name: 'Quality Matrix',
      href: '/admin/quality',
      icon: BarChart3,
      description: 'Quality metrics & evaluation'
    },
    {
      name: 'Quality Benchmarks',
      href: '/admin/quality-benchmarks',
      icon: FlaskConical,
      description: 'Benchmark samples & runs'
    },
    {
      name: 'Languages',
      href: '/admin/languages',
      icon: Languages,
      description: 'Supported languages by provider'
    },
    {
      name: 'Users',
      href: '/admin/users',
      icon: Users,
      description: 'User subscription management'
    },
    {
      name: 'Statistics',
      href: '/admin/statistics',
      icon: TrendingUp,
      description: 'Usage analytics & performance'
    },
  ]

  return (
    <div className="fixed inset-y-0 left-0 w-64 bg-gray-900 text-white pt-16" data-testid="admin-sidebar">
      <div className="flex flex-col h-full">
        {/* Admin Header */}
        <div className="px-4 py-4 border-b border-gray-700">
          <div className="flex items-center space-x-2">
            <Shield className="w-6 h-6 text-amber-400" />
            <span className="text-lg font-semibold">Admin Panel</span>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto" data-testid="admin-nav">
          {navigation.map((item) => {
            const isActive = location.pathname === item.href ||
                            location.pathname.startsWith(item.href + '/')
            return (
              <Link
                key={item.name}
                to={item.href}
                data-testid={`admin-nav-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
                className={clsx(
                  'flex items-center space-x-3 px-3 py-2.5 rounded-lg text-sm transition-colors group',
                  isActive
                    ? 'bg-amber-600 text-white'
                    : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                )}
              >
                <item.icon className={clsx(
                  'w-5 h-5 flex-shrink-0',
                  isActive ? 'text-white' : 'text-gray-400 group-hover:text-white'
                )} />
                <div className="flex-1 min-w-0">
                  <span className="block font-medium">{item.name}</span>
                  <span className={clsx(
                    'block text-xs truncate',
                    isActive ? 'text-amber-100' : 'text-gray-500 group-hover:text-gray-400'
                  )}>
                    {item.description}
                  </span>
                </div>
              </Link>
            )
          })}
        </nav>

        {/* Back to App */}
        <div className="p-4 border-t border-gray-700">
          <Link
            to="/dashboard"
            className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors text-sm"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Back to App</span>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default AdminSidebar
